import { IControlledPID } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { themedUseStyletron } from '../../../theme/customTheme';
import { SmallPanel } from './SmallPanel'
import { AiOutlineControl } from 'react-icons/ai';
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart';


export function OverviewPanel(props: IControlledPID) {
    const [css, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper height={theme.appSizes.smallAppHeight} icon={<AiOutlineControl size={'100%'}  color={theme.colors.backgroundPrimary}></AiOutlineControl>} small {...props}>
            <OverviewPanelContent {...props}></OverviewPanelContent>
        </OverviewPanelWrapper>
    );
}

export function OverviewPanelContent(props: IControlledPID) {
    const [css, theme] = themedUseStyletron();

    return (<>
        <SmallPanel {...props}></SmallPanel>
        <TimeSeriesLineChart lines={[{
                label: `Output`,
                lineColor: theme.appColors.aggregate.output,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'y',
                currentValue: props.y,
                showPoints: false,
                fill: false,
                grace: 0,
            },
            {
                label: `Setpoint`,
                lineColor: theme.appColors.aggregate.setpoint,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'w',
                currentValue: props.w,
                showPoints: true,
                fill: false,
                yScaleId: 'y1',
                grace: 0,
            },
            {
                label: `Actual Value`,
                lineColor: theme.appColors.aggregate.actualValue,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'x',
                currentValue: props.x,
                showPoints: false,
                fill: false,
                yScaleId: 'y1',
                grace: 0,
            }]}
            summarizeBy={'1s'}
            timespan={24 * 60}></TimeSeriesLineChart>
        
    </>)
}